import { lowerCase as _lowerCase } from "lodash";

const getSubdomainString = function () {
    let hostparts = window.location.hostname.split(".");
    let sub = _lowerCase(hostparts.shift());
    let subDomain;
       if (["localhost", "cleanfi", "www", "app"].includes(sub)) {
      // themeId.setAttribute("data-theme", `default`);
      subDomain = '';
    } else {
      // themeId.setAttribute("data-theme", `${sub}`);
      subDomain = `${sub}`;
    }
    return subDomain;
};

export default getSubdomainString;